export * from "fp-ts/lib/number";

import { constant } from "fp-ts/lib/function";

export const constZero = constant<0>(0);
